import React, {Component} from 'react';
import LEX from '@homeaway/react-lex';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
const {localizeUrl} = require('@homeaway/localization-utils');

class BirdhouseComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceUrl: this.props.serviceUrl
        };
        this.componentDidMount = this.componentDidMount.bind(this);
        this.redirectPostLogin = this.redirectPostLogin.bind(this);
    }

    componentDidMount() {
    }

    redirectPostLogin() {
        if (typeof window !== 'undefined') {
            let url;
            if (this.props.landingPage === 'success') {
                url = this.state.serviceUrl;
            } else {
                url = `/auth/traveler/login?service=${encodeURIComponent(this.state.serviceUrl)}${this.props.ticket === '' ? '&authui=false' : ''}`;
            }
            window.location.href = localizeUrl(url, window.__SITE_CONTEXT__);
        }
    }

    render() {
        AbacusClientUtils.initialize(this.props.experiments);
        const expediaExperiment = AbacusClientUtils.evaluateExperimentAndLog('HA_IDA_EXPEDIA_ICON_TEST');
        let expediaIconDisplayed = false;
        if (expediaExperiment && expediaExperiment.value === 1) {
            expediaIconDisplayed = true;
        }
        // Check to see if we are being server side rendered
        let service = (typeof window !== 'undefined') ? window.location.href : '';
        return (
            <div className="BirdhouseComponent">
                <LEX
                    service={service}
                    locale={this.props.site.locale}
                    site={this.props.site.siteName}
                    siteName={this.props.site.siteReadableName}
                    handleLoginSuccess={this.redirectPostLogin}
                    expediaIconDisplayed={expediaIconDisplayed}
                    serverConfigRendering
                    ticketId={this.props.ticket}
                    landingPage={this.props.landingPage}
                    theme={this.props.site.theme}
                />
            </div>
        );
    }
}

export default BirdhouseComponent;
